import { isEqual } from "lodash"
import Image from "next/image"
import React, { useState } from "react"
import { Icon } from "@/core/components/icon/Icon"
import { cn } from "@/utils/helpers"
import { ImageWithFallback } from "../ImageWithFallback"

type CompanyAvatarProps = Omit<
  React.ComponentProps<typeof Image> & {
    spaceId: string
    onError?: () => void
    fallbackElement?: JSX.Element | null
  },
  "src"
>

export const CompanyAvatar = React.memo(
  ({
    fallbackElement = null,
    onError,
    spaceId,
    className,
    ...props
  }: CompanyAvatarProps) => {
    return (
      <ImageWithFallback
        className={cn("aspect-square object-contain", className)}
        src={`https://cdn.flextribe.io/organisations/logos/${spaceId}`}
        {...props}
      >
        {fallbackElement || (
          <div
            className={cn(
              "flex aspect-square h-10 w-full items-center justify-center",
              className,
            )}
            style={{
              width: props.width,
              height: props.height,
            }}
          >
            <Icon icon="image" className="text-primary h-6 w-6" size="lg" />
          </div>
        )}
      </ImageWithFallback>
    )
  },
  (prev, next) => isEqual(prev, next),
)

CompanyAvatar.displayName = "CompanyAvatar"
